@if (numHistoryItems && numHistoryItems > 0) {
  <div class="box-management">
    <div class="header-box">
      <div class="title-box">
        <img src="assets/images/icons/s-superbid-icon.svg">
        <span>HISTÓRICO SUPERBID</span>
      </div>
      <div class="offer-detail mt-1">
        Oferta: {{ superBidOfferId || 'Não integrado' }} - Lote: {{ superBidLotId }}
      </div>
    </div>

    <div class="history-content" [perfectScrollbar]="{ suppressScrollX: true }">
      <div class="timeline">
        @for (item of items; track item; let last = $last) {
          <div class="timeline-item" [class.last]="last">
            <div class="timeline-left">
              <div class="icon-circle" [ngClass]="{ 'icon-ok': !typeError.includes(item.type), 'icon-error': typeError.includes(item.type) }">
                <i class="material-icons">{{ typeError.includes(item.type) ? 'error' : 'check_circle' }}</i>
              </div>
              <div class="timeline-line"></div>
            </div>

            <div class="timeline-right">
              <div class="item-header">
                <span class="item-type-label">{{ SuperBidHistoryEntryType[item.type] }}{{ item.details ? ' - ' + item.details : '' }}</span>
              </div>

              <div class="timestamp-top">
                {{ item.createdAt | date: "dd/MM/yyyy" }} às {{ item.createdAt | date: "HH:mm" }}
              </div>

              @if (item.fieldTypes?.length) {
                <div class="diff-container">
                  <span class="diff-label">Campos · {{ getItemFieldsLabels(item) }}</span>
                </div>
              }

              @for (diff of item.diffs; track diff) {
                <div class="diff-container">
                  <span class="diff-label">
                    Atualização: {{ SuperBidHistoryFieldAuction[diff.fieldName] }}
                    {{ diff.originalValue ? 'de ' + diff.originalValue + ' → ' : '' }}{{ diff.newValue }}
                  </span>
                </div>
              }

            </div>
          </div>
        }

        @if (showMore) {
          <div class="timeline-item last">
            <div class="timeline-left">
              <div class="icon-circle" style="background-color: #a6aaaf;">
                <i class="material-icons">more_horiz</i>
              </div>
            </div>
            <div class="timeline-right">
              <span class="link" style="font-size: 12px; color: #16b097; cursor: pointer; font-weight: 600;" (click)="onClickFullHistory()">
                ver todos ({{ numHistoryItems }})
              </span>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
}
